import { render, staticRenderFns } from "./SettingsPanel.vue?vue&type=template&id=f3045cac&scoped=true"
import script from "./SettingsPanel.vue?vue&type=script&lang=ts"
export * from "./SettingsPanel.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SettingsPanel.vue?vue&type=style&index=0&id=f3045cac&prod&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f3045cac",
  null
  ,true
)

export default component.exports